import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  spacing: 8,
  palette: {
    mode: 'light',
    primary: {
      main: '#12a655',
    },
    secondary: {
      main: '#f9a826',
    },
    background: {
      default: '#f4f6fb',
      paper: '#ffffff',
    },
  },
  typography: {
    fontFamily: [
      'Montserrat',
      'Inter',
      'system-ui',
      '-apple-system',
      'Segoe UI',
      'Roboto',
      'Helvetica',
      'Arial',
      'sans-serif',
    ].join(','),
    h1: { fontSize: '32px', fontWeight: 800, lineHeight: 1.2 },
    h2: { fontSize: '26px', fontWeight: 800, lineHeight: 1.25 },
    h3: { fontSize: '22px', fontWeight: 700, lineHeight: 1.3 },
    h4: { fontSize: '18px', fontWeight: 700, lineHeight: 1.35 },
    h5: { fontSize: '16px', fontWeight: 700, lineHeight: 1.4 },
    h6: { fontSize: '14px', fontWeight: 700, lineHeight: 1.45 },
    body1: { fontSize: '16px', fontWeight: 400, lineHeight: 1.6 },
    body2: { fontSize: '14px', fontWeight: 400, lineHeight: 1.55 },
    caption: { fontSize: '12px', fontWeight: 400, lineHeight: 1.4 },
    button: { textTransform: 'none', fontWeight: 600 },
  },
  components: {
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
      styleOverrides: {
        root: {
          borderRadius: 10,
          minHeight: 40,
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 12,
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: '0 6px 20px rgba(0,0,0,0.06)',
          backgroundColor: '#ffffff',
        },
      },
    },
    MuiCardContent: {
      styleOverrides: {
        root: {
          padding: 16,
          '&:last-child': {
            paddingBottom: 16,
          },
        },
      },
    },
    MuiDataGrid: {
      styleOverrides: {
        root: {
          color: 'var(--gray-900)',
        },
        columnHeaders: {
          backgroundColor: 'var(--gray-50)',
        },
        columnHeaderTitle: {
          fontWeight: 700,
        },
        row: {
          '&:hover': {
            backgroundColor: 'var(--gray-100)',
          },
        },
        cell: {
          color: 'var(--gray-900)',
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 999,
          fontWeight: 600,
        },
        colorDefault: {
          backgroundColor: 'var(--gray-100)',
          color: 'var(--gray-700)',
        },
        colorSuccess: {
          backgroundColor: '#dcfce7',
          color: '#166534',
        },
        colorWarning: {
          backgroundColor: '#fef3c7',
          color: '#92400e',
        },
        colorError: {
          backgroundColor: '#fee2e2',
          color: '#991b1b',
        },
        colorInfo: {
          backgroundColor: '#e0f2fe',
          color: '#075985',
        },
      },
    },
    MuiBadge: {
      styleOverrides: {
        badge: {
          fontWeight: 700,
          minWidth: 18,
          height: 18,
          padding: '0 4px',
        },
        colorDefault: {
          backgroundColor: 'var(--gray-400)',
          color: '#fff',
        },
      },
    },
    MuiTextField: {
      defaultProps: {
        size: 'small',
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          minHeight: 40,
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: 10,
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: 'var(--gray-300)',
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: 'var(--gray-400)',
          },
          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: 'var(--color-primary)',
            boxShadow: '0 0 0 2px rgba(18, 166, 85, 0.12)',
          },
        },
      },
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          color: 'var(--gray-700)',
          '&.Mui-focused': {
            color: 'var(--color-primary)',
          },
        },
      },
    },
  },
});

export default theme;
